<template>
  
  <WidgetVue 
      title="Frequently Used Keywords" 
      desc="These words are ordered by the frequency. Most common words reflect the most common themes.">

  <div id="fqk">

    <div class="row fqk_box">
      <ul>
        <li
          v-for="wf_item in datum.wf.slice(0, 30).filter((x) => x.positive_perc !== 0)"
          :key="wf_item.word"
          :style="
            `color: white; font-weight:bold; background: linear-gradient(to right, black ` +
            wf_item.positive_perc +
            `%, black  ` +
            wf_item.negative_perc +
            `%);`
          "
        >
          {{ wf_item.word }}
        </li>
      </ul>
    </div>
  </div>
  </WidgetVue>
</template>

<script>
import WidgetVue from "@/components/WidgetVue.vue"
export default {
  props: ["datum"],
  components: {
  WidgetVue
  }
};
</script>

<style>
#fqk ul {
  list-style: none;
  background-color: white;
  text-align: center;
}

#fqk ul li {
  border-radius: 0.2em;
  margin: 1px;
  margin-right: 1em;
  display: inline-block;
  font-size: x-large;
  font-weight: bold;
  padding: 1px;
}
</style>
